import {createContext} from "react";
import QRCodeStyle from "../../../../../api/qr-code/style/QRCodeStyle";
import QRCodeStyleViewTypes from "./QRCodeStyleViewTypes";
import QRCode from "../../../../../api/qr-code/QRCode";
import Payload from "./Payload";
import QRCodeStyling, {Options} from "qr-code-styling";

type QRCodeStyleViewContextType = {
    /**
     * @since 0.1.9
     * @author Kacper Faber
     */
    style: QRCodeStyle | undefined | null;

    /**
     * Payload in context
     * @since 0.1.9
     * @author Kacper Faber
     */
    payload: Payload | undefined;

    /**
     * Render QRCode using current payload.
     * @author Kacper Faber
     * @since 0.1.9
     */
    render: (options: Partial<Options>) => QRCodeStyling;

    /**
     * Render QRCode using current payload, and return as a file.
     * @author Kacper Faber
     * @since 0.1.9
     */
    renderFile: (options: Partial<Options>) => Promise<File>;

    /**
     * Set the payload in context
     * @since 0.1.9
     * @author Kacper Faber
     */
    setPayload: (payload: Payload) => void;

    /**
     * Set the style in context
     * @since 0.1.9
     * @author Kacper Faber
     */
    setStyle: (style: QRCodeStyle | null) => void;

    /**
     * Active view
     * @author Kacper Faber
     * @since 0.1.9
    */
    activeView: QRCodeStyleViewTypes

    /**
     * Change the active QRCodeStyleViewTypes.
     * You will change the visible view this way
     * @author Kacper Faber
     * @since 0.1.9
    */
    setActiveView: (activeView: QRCodeStyleViewTypes) => void;

    /**
     * QRCode from API
     * @since 0.1.9
     * @author Kacper Faber
     */
    qrCode: QRCode | undefined;

    /**
     * Set QRCode in this context
     * @since 0.1.9
     * @author Kacper Faber
     */
    setQRCode: (qrCode: QRCode | undefined) => void;

    /**
     * Update or create new QRCodeStyle.
     * Will update the 'style', if success.
     * @since 0.1.9
     * @author Kacper Faber
     */
    save: () => Promise<QRCodeStyle>;
}

const notImplemented = () => { throw new Error('Not implemented!') };

/**
 * Default context value
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaults: QRCodeStyleViewContextType = {
    save: notImplemented,
    style: undefined,
    payload: undefined,
    setStyle: notImplemented,
    setPayload: notImplemented,
    activeView: 'index',
    setActiveView: notImplemented,
    qrCode: undefined,
    setQRCode: notImplemented,
    render: notImplemented,
    renderFile: notImplemented
};

/**
 * @since 0.1.9
 * @author Kacper Faber
 */
const ctx = createContext<QRCodeStyleViewContextType>(defaults);

export default ctx;